import { cn } from "../utils";

export function Button({
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={cn(
        "rounded-full bg-rose-500 px-6 py-2 text-white hover:bg-rose-400",
        className
      )}
      {...props}
    />
  );
}

